import { render, staticRenderFns } from "./FailuresTwoSettings.vue?vue&type=template&id=81037676&"
import script from "./FailuresTwoSettings.vue?vue&type=script&lang=js&"
export * from "./FailuresTwoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports